export function arrayToMap<T, K extends string>(arr: T[], field: keyof T): Record<K, T> {
  const record: Record<K, T> = {} as any;

  for (const item of arr) {
    record[item[field] as K] = item;
  }

  return record;
}

export function arrayChanges<DataType>(
  oldArray: DataType[],
  newArray: DataType[],
): {
  added: DataType[];
  removed: DataType[];
} {
  const added: DataType[] = [];
  const removed: DataType[] = [];

  for (const oldElement of oldArray) {
    if (!newArray.includes(oldElement)) {
      removed.push(oldElement);
    }
  }

  for (const newElement of newArray) {
    if (!oldArray.includes(newElement)) {
      added.push(newElement);
    }
  }

  return { added, removed };
}
